import { render, staticRenderFns } from "./CustomFieldOption.vue?vue&type=template&id=886661ea&scoped=true&"
import script from "./CustomFieldOption.vue?vue&type=script&lang=js&"
export * from "./CustomFieldOption.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldOption.vue?vue&type=style&index=0&id=886661ea&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886661ea",
  null
  
)

export default component.exports